<template>
  <div class="order-details">
    <!-- 给header上与data上加on为退款订单-->
    <div
      class="header bg-color-red acea-row row-middle"
      :class="refundOrder ? 'on' : ''"
    >
      <div class="pictrue" v-if="!refundOrder">
        <img src="@assets/images/dfk001.gif" v-if="orderInfo.status === 0" />
        <img src="@assets/images/dfh001.gif" v-if="orderInfo.status === 1" />
        <img src="@assets/images/dsh001.gif" v-if="orderInfo.status === 2" />
        <img
          src="@assets/images/dpj001.gif"
          v-if="orderInfo.status === 3 && orderInfo.isComment === 0"
        />
        <img
          src="@assets/images/ywc001.gif"
          v-if="orderInfo.status === 3 && orderInfo.isComment === 1"
        />
      </div>
      <div class="data" :class="refundOrder ? 'on' : ''">
        <div class="state" v-if="orderInfo.status === 0">
          请在{{ formatDate(orderInfo.createTime + 3 * 60 * 1000) }}前完成支付！
        </div>
        <div class="state" v-if="orderInfo.status === 1">
          已付款，请签字确认！
        </div>
        <div class="state" v-if="orderInfo.status === 2">
          已签字，感谢你的信任，快去给个好评吧
        </div>
        <div
          class="state"
          v-if="orderInfo.status === 3 && orderInfo.isComment === 0"
        >
          感谢你的信任，快去给个好评吧
        </div>
        <div
          class="state"
          v-if="orderInfo.status === 3 && orderInfo.isComment === 1"
        >
          感谢你的信任，祝您生活愉快
        </div>
        <div class="state" v-if="orderInfo.status === -1">订单已经被取消</div>
        <div>
          {{ formatDate(orderInfo.createTime) }}
        </div>
      </div>
    </div>
    <template v-if="!refundOrder">
      <div class="nav">
        <div class="navCon acea-row row-between-wrapper">
          <div :class="{ on: status.type === 0 }" v-if="orderInfo.status > 0">
            待付款
          </div>
          <div :class="{ on: status.type === 0 }" v-else>已付款</div>
          <div :class="{ on: status.type === 1 }" v-if="orderInfo.status > 1">
            已签字
          </div>
          <div :class="{ on: status.type === 1 }" v-else>待签字</div>
          <div :class="{ on: status.type === 3 && orderInfo.isComment === 0 }">
            待评价
          </div>
          <div :class="{ on: status.type === 3 && orderInfo.isComment === 1 }">
            已完成
          </div>
        </div>
        <div class="progress acea-row row-between-wrapper">
          <div
            class="iconfont"
            :class="[
              status.type === 0 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 0 ? 'font-color-red' : '',
            ]"
          ></div>
          <div
            class="line"
            :class="{ 'bg-color-red': status.type > 0 && status.type != 9 }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 1 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : '',
            ]"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type > 1 && status.type != 6 && status.type != 9,
            }"
            v-if="orderInfo.expressType === 1"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 2 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : '',
            ]"
            v-if="orderInfo.expressType === 1"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type > 2 && status.type != 6 && status.type != 9,
            }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type === 3 && orderInfo.isComment === 0
                ? 'icon-webicon318'
                : 'icon-yuandianxiao',
              status.type >= 3 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : '',
            ]"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type == 3 &&
                orderInfo.isComment === 1 &&
                status.type != 6 &&
                status.type != 9,
            }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type == 3 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type == 3 &&
              orderInfo.isComment === 1 &&
              status.type != 6 &&
              status.type != 9
                ? 'font-color-red'
                : '',
            ]"
          ></div>
        </div>
      </div>
    </template>

    <OrderGoods
      :evaluate="status.type || 0"
      :cartInfo="orderInfo.items || []"
      :order="orderInfo"
      v-if="orderInfo.items"
    ></OrderGoods>

    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>订单编号：</div>
        <div class="conter acea-row row-middle row-right">
          {{ orderInfo.orderSn ? orderInfo.orderSn : orderInfo.id }}
          <span class="copy copy-data" :data-clipboard-text="orderInfo.orderSn"
            >复制</span
          >
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>下单时间：</div>
        <div class="conter">
          {{ formatDate(orderInfo.createTime) }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>订单类型：</div>
        <div class="conter" v-if="orderInfo.status == -4">已退款</div>
        <div class="conter" v-if="orderInfo.status == -2">已关闭</div>
        <div class="conter" v-if="orderInfo.status == -1">已取消</div>
        <div class="conter" v-if="orderInfo.status == 0">待付款</div>
        <div class="conter" v-if="orderInfo.status == 1">已付款</div>
        <div class="conter" v-if="orderInfo.status == 2">已签字</div>
        <div class="conter" v-if="orderInfo.status == 3">已评价</div>
      </div>
      <div class="item acea-row row-between">
        <div>订单状态：</div>
        <div class="conter">
          {{
            new Array("开卡订单", "充值订单", "服务订单")[orderInfo.orderType]
          }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>支付状态：</div>
        <div class="conter">{{ orderInfo.isPayed ? "已支付" : "未支付" }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>支付方式：</div>
        <div class="conter">
          {{
            new Array("微信", "支付宝", "现金", "刷卡", "会员卡抵扣", "余额")[
              orderInfo.payType
            ]
          }}
        </div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.money">
        <div>充值金额：</div>
        <div class="conter">{{ orderInfo.money }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.giveMoney">
        <div>赠送金额：</div>
        <div class="conter">{{ orderInfo.giveMoney }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.note">
        <div>订单备注：</div>
        <div class="conter">{{ orderInfo.note }}</div>
      </div>
    </div>

    <!--     退款订单详情 -->
    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>订单金额：</div>
        <div class="conter">￥{{ orderInfo.totalAmount }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>应付金额：</div>
        <div class="conter">￥{{ orderInfo.payAmount }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.couponAmount">
        <div>优 惠 券 ：</div>
        <div class="conter">-￥{{ orderInfo.couponAmount }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.useIntegral > 0">
        <div>积分抵扣：</div>
        <div class="conter">-￥{{ orderInfo.integrationAmount }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.vipAmount > 0">
        <div>会员优惠：</div>
        <div class="conter">-￥{{ orderInfo.vipAmount }}</div>
      </div>
      <div class="actualPay acea-row row-right">
        实际付款：<span class="money font-color-red"
          >￥{{ orderInfo.realAmount }}</span
        >
      </div>
    </div>

    <!-- 签字详情 -->
    <div class="wrapper" v-if="orderInfo.userSign">
      <div class="item acea-row row-between">
        <div>签字信息：</div>
        <div class="conter"></div>
      </div>
      <div class="sign-image">
        <img :src="orderInfo.userSign + '!sign'" />
      </div>
    </div>

    <div
      class="wrapper reply-wrapper"
      v-if="
        reply &&
        (reply.comment ||
          reply.healthScore ||
          reply.serviceScore ||
          reply.productScore ||
          (reply.waiters && reply.waiters.length))
      "
    >
      <div class="reply-item" v-if="reply.comment">
        <div class="title">用户评论：</div>
        <div>{{ reply.comment }}</div>
      </div>
      <!-- 新体系：环境卫生 + 技师维度（手艺/服务态度）评分 -->
      <template v-if="reply.waiters && reply.waiters.length > 0">
        <div class="reply-item" v-if="reply.healthScore">
          <div class="title">环境卫生：</div>
          <rate :value="reply.healthScore" readonly />
        </div>
        <div class="reply-item" v-for="w in reply.waiters" :key="w.waiterId">
          <div class="title">{{ w.waiterName }}：</div>
          <div class="waiter-rates">
            <div class="rate-line">
              <span class="rate-label">手艺：</span>
              <rate :value="w.skillScore" readonly />
            </div>
            <div class="rate-line">
              <span class="rate-label">服务态度：</span>
              <rate :value="w.attitudeScore" readonly />
            </div>
          </div>
        </div>
      </template>
      <!-- 迁移的历史评价：订单级三星级原样展示 -->
      <template v-else>
        <div class="reply-item" v-if="reply.healthScore">
          <div class="title">环境卫生：</div>
          <rate :value="reply.healthScore" readonly />
        </div>
        <div class="reply-item" v-if="reply.serviceScore">
          <div class="title">服务质量：</div>
          <rate :value="reply.serviceScore" readonly />
        </div>
        <div class="reply-item" v-if="reply.productScore">
          <div class="title">服务态度：</div>
          <rate :value="reply.productScore" readonly />
        </div>
      </template>
      <!-- 门店回复：新旧体系评价均展示，无回复内容时不渲染空框 -->
      <div class="reply-item" v-if="reply.storeReplyContent">
        <div class="title">门店回复：</div>
        <div class="content">{{ reply.storeReplyContent }}</div>
        <div
          class="time"
          v-if="reply.storeReplyUserName || reply.storeReplyTime"
        >
          {{ reply.storeReplyUserName
          }}<span v-if="reply.storeReplyUserName && reply.storeReplyTime">
            · </span
          >{{ formatDate(reply.storeReplyTime) }}
        </div>
      </div>
      <div class="reply-item" v-if="reply.reviewTime">
        <div class="title">评价时间：</div>
        <div>{{ dayjs(reply.reviewTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
      </div>
      <div v-if="imageList.length > 0">
        <img
          style="width: 80px; height: 80px; border-radius: 5px"
          v-for="url in imageList"
          :src="url"
          :key="url"
          @click="toPreview"
        />
      </div>
    </div>

    <div style="height: 1.2rem" v-if="!refundOrder && offlineStatus"></div>
    <div
      class="footer acea-row row-right row-middle"
      v-if="!refundOrder && offlineStatus"
    >
      <template v-if="status.type === 0">
        <div class="bnt cancel" @click="cancelOrder">取消订单</div>
        <div class="bnt bg-color-red" @click="pay = true">立即付款</div>
      </template>
      <template v-if="status.type === 4">
        <div class="bnt cancel" @click="delOrder">删除订单</div>
      </template>
    </div>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.money"
    ></Payment>
  </div>
</template>

<script>
import OrderGoods from "@components/OrderGoods";
import { orderDetail, fetchReviewView } from "@api/order";
import ClipboardJS from "clipboard";
import Payment from "@components/Payment";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import { Rate, ImagePreview } from "vant";
import { cancelOrderHandle, delOrderHandle, payOrderHandle } from "@libs/order";
import dayjs from "dayjs";

const NAME = "OrderDetails";

export default {
  name: NAME,
  components: {
    Rate,
    OrderGoods,
    Payment,
  },
  props: {},
  data: function () {
    return {
      dayjs,
      offlineStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {},
      },
      imageList: [],
      status: {},
      reply: {},
      pay: false,
      payType: ["weixin", "", "yue", ""],
      from: isWeixin() ? "weixin" : "weixinh5",
      system_store: {},
      mapKay: "",
      mapShow: false,
    };
  },
  computed: {
    refundOrder() {
      return this.orderInfo.status < 0;
    },
    ...mapGetters(["userInfo"]),
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    },
  },
  inject: ["app"],
  mounted: function () {
    this.getDetail();
    this.fetchReply();
    this.$nextTick(function () {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    fetchReply() {
      fetchReviewView(this.id).then((res) => {
        const result = res.result || {};
        this.reply = result.reviewed ? result.review || {} : null;
        if (this.reply && this.reply.pictures) {
          this.imageList = this.reply.pictures.split(",");
        }
      });
    },
    toPreview() {
      if (this.imageList.length > 0) {
        ImagePreview(this.imageList);
      }
    },
    goBack() {
      const history = this.app.history,
        last = history[history.length - 1] || {};
      if (last.name === "MyOrder") return this.$router.go(-1);
      else return this.$router.replace({ path: "/order/list/" });
    },
    cancelOrder() {
      cancelOrderHandle(this.orderInfo.order_id)
        .then(() => {
          setTimeout(() => this.goBack(), 300);
        })
        .catch(() => {
          this.getDetail();
        });
    },
    delOrder() {
      delOrderHandle(this.orderInfo.id).then(() => {
        setTimeout(() => this.goBack(), 300);
      });
    },
    getOrderStatus: function () {
      let orderInfo = this.orderInfo || {},
        _status = orderInfo.status;
      let type = parseInt(_status),
        status = { type: type, class_status: 0 };
      if (type === 4 || type === 0) status.class_status = 4; //删除订单
      this.status = status;
    },
    getDetail() {
      const id = this.id;
      if (!id) return this.$dialog.error("订单不存在");
      orderDetail(id)
        .then((res) => {
          this.orderInfo = res.result;
          this.getOrderStatus();
        })
        .catch((err) => {
          console.error(err);
          this.$dialog.error(err.msg);
        });
    },
    async toPay(type) {
      var that = this;
      await payOrderHandle(
        this.orderInfo.id,
        that.payType.indexOf(type),
        that.from
      )
        .then(() => {})
        .catch((res) => {
          if (res.status === "WECHAT_H5_PAY")
            that.$router.push({
              path: "/order/status/" + that.orderInfo.id + "/0",
            });
        });
      that.getDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
.sign-image {
  width: 100%;
  height: 132px;

  image {
    width: 100%;
    height: 100%;
  }
}
.reply-wrapper {
  .reply-item {
    display: flex;
    margin: 8px 2px;
  }

  .waiter-rates {
    .rate-line {
      display: flex;
      align-items: center;

      .rate-label {
        margin-right: 4px;
      }

      & + .rate-line {
        margin-top: 4px;
      }
    }
  }
}
</style>
